















































































import Vue from 'vue';
import api from '../services/api';
import Input from '~/components/Input.vue';
import CountryCodes from '~/components/CountryCodes.vue';
import VerifyModal from '~/components/VerifyModal.vue';
import Button from '~/components/Button.vue';
import LangPicker from '~/components/LangPicker.vue';

declare module 'vue/types/vue' {
  // 3. Declare augmentation for Vue
  interface Vue {
    $cookies: any;
    $t: any;
    $lang: any;
  }
}

export default Vue.extend({
  name: 'Login',
  components: {
    Input,
    Button,
    VerifyModal,
    LangPicker,
  },
  layout: 'headless',
  data() {
    return {
      registrationDetails: {} as any,
      error: '',
      showVerifyModal: false,
      preauthId: '',
      token: '',
      code: '370',
      phone: '',
      loading: false,
    };
  },
  mounted() {
    this.$root.$on('selected-code', this.setCode);
    if (this.$lang() === 'pl') {
      this.code = '48';
    }
    if (this.$route.query?.error === 'unregistered') {
      this.error = this.$t('error.userUnregistered');
    }
  },
  destroyed() {
    this.$root.$off('selected-code');
  },
  methods: {
    openIntercom() {
      (window as any).Intercom('showNewMessage');
    },
    async register() {
      this.loading = true;
      try {
        this.registrationDetails.phoneNumber = `+${
          this.code
        }${this.phone.trim()}`;
        this.registrationDetails.locale = this.$i18n.locale.split('-')[0];
        const response = await api.login(this, this.registrationDetails);
        this.preauthId = response.preauthId;
        this.loading = false;
        this.showVerifyModal = true;
      } catch (e) {
        this.loading = false;
        this.error = this.$t(e.message || 'common.errorOccurred');
      }
      // console.log('PREAUTH SUCCESS', this.preauthId);
    },
    selectCode() {
      this.$root.$emit('push-dialog', {
        component: CountryCodes,
        title: this.$t('home.search.mobileCountryOverlayText'),
      });
    },
    setCode(value: string) {
      this.code = value;
    },
    onVerify() {
      this.$router.push((this as any).localePath('/orders'));
    },
  },
});
